/* ORDERS */

import BasicLayout from '@/views/layouts/basic.vue';
import ordersOverview from '@/views/orders/list.vue';
import ordersOrderlines from '@/views/orders/orderlines/list.vue';
import ordersOrderline from '@/views/orders/orderlines/details.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
    path: 'orders',
    name: 'orders',
    meta: {title: 'Orders'},
    redirect: '/orders/overzicht',
    component: BasicLayout,
    children: [
        // Overview routes
        {
            path: 'overzicht',
            name: 'orders.overview',
            meta: {title: 'Orders'},
            component: ordersOverview,
            children: [
                {
                    path: ':status',
                    name: 'orders.overview.status',
                    meta: {title: 'Orders'},
                    component: ordersOverview,
                },
            ],
        },
        // Orderlines
        {
            path: ':transactionId',
            name: 'orders.orderlines',
            meta: {title: 'Orders'},
            component: ordersOrderlines,
            children: [
                {
                    path: ':status',
                    name: 'orders.orderlines.status',
                    meta: {title: 'Orders'},
                    component: ordersOrderlines,
                },
            ],
        },
        {
            path: ':transactionId/orderregel/:cpId',
            name: 'orders.orderline',
            meta: {title: 'Orders'},
            component: ordersOrderline,
        },
        {
            path: ':transactionId/orderregel/:cpId/comments/latest',
            name: 'orders.orderline.comment.latest',
            meta: {title: 'Laatste commentaar'},
            component: ordersOrderline,
        },
    ],
};
